import React from 'react';
import Notification from '../../Shared/Notifications';
import { newRule } from './services/rules';
import { BUTTON_LINE_ICON } from '../../Shared/Constants';
import ClipLoader from "react-spinners/ClipLoader";
import mitt from 'mitt';
import { encodePermissions, parsePermissions } from '../../Shared/functions';


class NewRule extends React.Component {
    emitter = mitt();
    constructor(props) {
        super(props);
        this.state = {
            roleName: '',
            permissions: [
                {
                   rules: [
                       {name: 'see', value: false},
                       {name: 'create', value: false},
                       {name: 'update', value: false},
                       {name: 'delete', value: false},
                       {name: 'search', value: false}
                   ],
                   analyst: [
                       {name: 'see', value: false},
                       {name: 'create', value: false},
                       {name: 'update', value: false},
                       {name: 'delete', value: false},
                       {name: 'search', value: false}
                   ],
                   officials: [
                       {name: 'see', value: false},
                       {name: 'create', value: false},
                       {name: 'update', value: false},
                       {name: 'delete', value: false},
                       {name: 'search', value: false}
                   ],
                    penalities: [
                       {name: 'see', value: false},
                       {name: 'create', value: false},
                       {name: 'update', value: false},
                       {name: 'delete', value: false},
                       {name: 'search', value: false},
                       {name: 'exonere', value: false},
                       {name: 'status', value: false}
                   ],
                    vehicles: [
                       {name: 'see', value: false},
                       {name: 'create', value: false},
                       {name: 'update', value: false},
                       {name: 'delete', value: false},
                       {name: 'search', value: false}
                   ],
                   concepts: [
                        {name: 'see', value: false},
                       {name: 'create', value: false},
                       {name: 'update', value: false},
                       {name: 'delete', value: false},
                       {name: 'search', value: false}
                   ],
                   factor: [
                        {name: 'see', value: false},
                        {name: 'create', value: false},
                        {name: 'update', value: false},
                        {name: 'delete', value: false},
                        {name: 'search', value: false}
                    ],
                   audit: [
                        {name: 'see', value: false},
                        {name: 'create', value: false},
                        {name: 'update', value: false},
                        {name: 'delete', value: false},
                        {name: 'search', value: false}
                   ],
                   treasury: [
                        {name: 'see', value: false},
                        {name: 'search', value: false}
                    ],
                    revocations: [
                        {name: 'see', value: false},
                        {name: 'update', value: false},
                    ],
                    paymentValidation: [
                        {name: 'see', value: false},
                        {name: 'update', value: false},
                        {name: 'search', value: false},
                    ],
                    officialFines: [
                        {name: 'see', value: false},
                        {name: 'search', value: false},
                    ]
                }
            ],
            showNotification: false,
            disabledButton: false,
            isUpdate: false,
            loadingForm:false,
            errorMessage: '',
        };
    }

    componentDidMount = () => {
        if(this.props.item) {
            const permissions = parsePermissions(this.props.item.permissions);
            this.setState({
                isUpdate:true,
                permissions: permissions,
                roleName:this.props.item.roleName
            })
        }
    }


    endItemCreation = () => {
        this.setState({disabledButton:true, loadingForm:true, errorMessage: ''});
        newRule({
            id: this.state.isUpdate ? this.props.item.id : 0,
            roleName: this.state.roleName,
            // El backend rechaza comillas dobles dentro de cadenas; se codifican.
            permissions: encodePermissions(JSON.stringify(this.state.permissions)),
            active: true,
        }).then(res => {
            // El servicio devuelve undefined o un mensaje cuando el backend falla;
            // antes se cerraba el panel como si hubiera guardado.
            const saved = res && res.status === 200 && res.data && res.data.error === 0;
            if(!saved) {
                const message = (res && res.data && res.data.message) || (typeof res === 'string' ? res : '') || 'No se pudo guardar el grupo. Intente nuevamente.';
                this.setState({loadingForm:false, disabledButton:false, errorMessage: message});
                return;
            }
            this.setState({loadingForm:false})
            this.emitter.emit('reload');
            this.props.closeDialog();
        }).catch(err => {
            console.log(err);
            this.setState({loadingForm:false, disabledButton:false, errorMessage: 'No se pudo guardar el grupo. Intente nuevamente.'});
        });
    }


    renderNotification = () => {
        return(
            <Notification 
                show={this.state.showNotification}
                title={'Datos almacenados'}
                subtitle={'Sus datos fueron almacenados correctamente.'}
            />
        )
    }

    setRole = (role, subRole) => {
        const permissions = this.state.permissions;
        const roleIndex = permissions.findIndex(roleItem => roleItem[role]);
        if(roleIndex !== -1 ) {
            const permissionIndex = permissions[roleIndex][role].findIndex(p => p.name === subRole);
                if (permissionIndex !== -1) {
                    permissions[roleIndex][role][permissionIndex].value = !permissions[roleIndex][role][permissionIndex].value;
                }else{
                    permissions[roleIndex][role].push({name: subRole, value: true});
                }
        }else{
            permissions[0][role] = [{ name:'see', value: true }];
        }
        this.setState({permissions: permissions});
    }

    getValue = (role, subRole) => {
        const permissions = this.state.permissions;
        const roleIndex = permissions.findIndex(roleItem => roleItem[role]);
        if(roleIndex !== -1 ) {
            const permissionIndex = permissions[roleIndex][role].findIndex(p => p.name === subRole);
                if (permissionIndex !== -1) {
                    return permissions[roleIndex][role][permissionIndex].value;
                }
        }
    }

    render() {
        return(
            <div>
                {
                    this.state.loadingForm?
                        <center>
                            <ClipLoader
                                color={'gray'}
                                loading={true}
                                size={50}
                                aria-label="Loading Spinner"
                                data-testid="loader"/>
                        </center>
                    :
            <div className='space-y-12'>
                <div className="border-b border-gray-900/10 pb-12">
                    <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div className="sm:col-span-4">
                            <p className="mt-1 text-sm/6 text-gray-600">
                                Esta informacion es completamente confidencial, asegurese de ingresar los datos correctamente.
                            </p>
                            <label htmlFor='roleName' className="text-base/7 font-semibold text-gray-900">
                                Nombre del Grupo
                            </label>
                            <div className="mt-2">
                                <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                        <input
                                            disabled={this.state.isUpdate ? true : false}
                                            value={this.state.roleName}
                                            id="roleName"
                                            name="roleName"
                                            type="text"
                                            placeholder=""
                                            autoComplete=""
                                            className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                            onChange={(e) => this.setState({roleName: e.target.value})}
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="border-b border-gray-900/10 pb-12">
                    <h2 className="text-base/7 font-semibold text-gray-900">Permisología de Grupos</h2>
                    <p className="mt-1 text-sm/6 text-gray-600">
                        Por favor indicar que permisos y que accesos tendra el rol
                    </p>

                    <div className="mt-10 space-y-10">
                        <fieldset>
                            <legend className="text-sm/6 font-semibold text-gray-900">Lista de permisos</legend>
                                                            <div>
                                    <div className="mt-6 space-y-6">
                                        <div className="relative flex gap-x-3">
                                            <div className="text-sm/6">
                                                <label htmlFor="comments" className="font-medium text-gray-900">
                                                    <strong>Módulo de Grupos </strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className='relative flex gap-x-3'>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Ver</p>
                                                <input
                                                    checked={this.getValue('rules','see')}
                                                    onChange={(e) => this.setRole('rules','see')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Crear</p>
                                                <input
                                                    checked={this.getValue('rules','create')}
                                                    onChange={(e) => this.setRole('rules','create')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Actualizar</p>
                                                <input
                                                    checked={this.getValue('rules','update')}
                                                    onChange={(e) => this.setRole('rules','update')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-6 space-y-6">
                                        <div className="relative flex gap-x-3">
                                            <div className="text-sm/6">
                                                <label htmlFor="comments" className="font-medium text-gray-900">
                                                    <strong>Módulo de Usuarios</strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className='relative flex gap-x-3'>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Ver</p>
                                                <input
                                                    checked={this.getValue('analyst','see')}
                                                    onChange={(e) => this.setRole('analyst','see')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Crear</p>
                                                <input
                                                    checked={this.getValue('analyst','create')}
                                                    onChange={(e) => this.setRole('analyst','create')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Actualizar</p>
                                                <input
                                                    checked={this.getValue('analyst','update')}
                                                    onChange={(e) => this.setRole('analyst','update')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-6 space-y-6">
                                        <div className="relative flex gap-x-3">
                                            <div className="text-sm/6">
                                                <label htmlFor="comments" className="font-medium text-gray-900">
                                                    <strong>Módulo de Funcionarios</strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className='relative flex gap-x-3'>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Ver</p>
                                                <input
                                                    checked={this.getValue('officials','see')}
                                                    onChange={(e) => this.setRole('officials','see')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Crear</p>
                                                <input
                                                    checked={this.getValue('officials','create')}
                                                    onChange={(e) => this.setRole('officials','create')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Actualizar</p>
                                                <input
                                                    checked={this.getValue('officials','update')}
                                                    onChange={(e) => this.setRole('officials','update')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-6 space-y-6">
                                        <div className="relative flex gap-x-3">
                                            <div className="text-sm/6">
                                                <label htmlFor="comments" className="font-medium text-gray-900">
                                                    <strong>Módulo de Multas</strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className='relative flex gap-x-3'>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Ver</p>
                                                <input
                                                    checked={this.getValue('penalities','see')}
                                                    onChange={(e) => this.setRole('penalities','see')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Crear</p>
                                                <input
                                                    checked={this.getValue('penalities','create')}
                                                    onChange={(e) => this.setRole('penalities','create')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Actualizar</p>
                                                <input
                                                    checked={this.getValue('penalities','update')}
                                                    onChange={(e) => this.setRole('penalities','update')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Exonerar</p>
                                                <input
                                                    checked={this.getValue('penalities','exonere')}
                                                    onChange={(e) => this.setRole('penalities','exonere')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Actualizar Estado</p>
                                                <input
                                                    checked={this.getValue('penalities','status')}
                                                    onChange={(e) => this.setRole('penalities','status')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-6 space-y-6">
                                        <div className="relative flex gap-x-3">
                                            <div className="text-sm/6">
                                                <label htmlFor="comments" className="font-medium text-gray-900">
                                                    <strong>Módulo de Conceptos</strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className='relative flex gap-x-3'>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Ver</p>
                                                <input
                                                    checked={this.getValue('concepts','see')}
                                                    onChange={(e) => this.setRole('concepts','see')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Crear</p>
                                                <input
                                                    checked={this.getValue('concepts','create')}
                                                    onChange={(e) => this.setRole('concepts','create')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Actualizar</p>
                                                <input
                                                    checked={this.getValue('concepts','update')}
                                                    onChange={(e) => this.setRole('concepts','update')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-6 space-y-6">
                                        <div className="relative flex gap-x-3">
                                            <div className="text-sm/6">
                                                <label htmlFor="comments" className="font-medium text-gray-900">
                                                    <strong>Módulo de Factor</strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className='relative flex gap-x-3'>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Ver</p>
                                                <input
                                                    checked={this.getValue('factor','see')}
                                                    onChange={(e) => this.setRole('factor','see')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Crear</p>
                                                <input
                                                    checked={this.getValue('factor','create')}
                                                    onChange={(e) => this.setRole('factor','create')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Actualizar</p>
                                                <input
                                                    checked={this.getValue('factor','update')}
                                                    onChange={(e) => this.setRole('factor','update')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-6 space-y-6">
                                        <div className="relative flex gap-x-3">
                                            <div className="text-sm/6">
                                                <label htmlFor="comments" className="font-medium text-gray-900">
                                                    <strong>Módulo de Auditoría</strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Ver</p>
                                                <input
                                                    checked={this.getValue('vehicles','see')}
                                                    onChange={(e) => this.setRole('vehicles','see')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                        </div>
                                    </div>
                                    <div className="mt-6 space-y-6">
                                        <div className="relative flex gap-x-3">
                                            <div className="text-sm/6">
                                                <label htmlFor="comments" className="font-medium text-gray-900">
                                                    <strong>Módulo de Tesorería</strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className='relative flex gap-x-3'>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Ver</p>
                                                <input
                                                    checked={this.getValue('treasury','see')}
                                                    onChange={(e) => this.setRole('treasury','see')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Consultar</p>
                                                <input
                                                    checked={this.getValue('treasury','search')}
                                                    onChange={(e) => this.setRole('treasury','search')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-6 space-y-6">
                                        <div className="relative flex gap-x-3">
                                            <div className="text-sm/6">
                                                <label htmlFor="comments" className="font-medium text-gray-900">
                                                    <strong>Módulo de Revocaciones</strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className='relative flex gap-x-3'>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Ver</p>
                                                <input
                                                    checked={this.getValue('revocations','see')}
                                                    onChange={(e) => this.setRole('revocations','see')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Actualizar</p>
                                                <input
                                                    checked={this.getValue('revocations','update')}
                                                    onChange={(e) => this.setRole('revocations','update')}
                                                    id="comments"
                                                    name="comments"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-6 space-y-6">
                                        <div className="relative flex gap-x-3">
                                            <div className="text-sm/6">
                                                <label className="font-medium text-gray-900">
                                                    <strong>Módulo de Validación de Pagos</strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className='relative flex gap-x-3'>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Ver</p>
                                                <input
                                                    checked={this.getValue('paymentValidation','see')}
                                                    onChange={() => this.setRole('paymentValidation','see')}
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Aprobar/Rechazar</p>
                                                <input
                                                    checked={this.getValue('paymentValidation','update')}
                                                    onChange={() => this.setRole('paymentValidation','update')}
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Consultar</p>
                                                <input
                                                    checked={this.getValue('paymentValidation','search')}
                                                    onChange={() => this.setRole('paymentValidation','search')}
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-6 space-y-6">
                                        <div className="relative flex gap-x-3">
                                            <div className="text-sm/6">
                                                <label className="font-medium text-gray-900">
                                                    <strong>Módulo de Multas por Funcionario</strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className='relative flex gap-x-3'>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Ver</p>
                                                <input
                                                    checked={this.getValue('officialFines','see')}
                                                    onChange={() => this.setRole('officialFines','see')}
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                            <div className="flex h-6 items-center">
                                                <p style={{paddingRight:5, fontSize:16}}>Consultar</p>
                                                <input
                                                    checked={this.getValue('officialFines','search')}
                                                    onChange={() => this.setRole('officialFines','search')}
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            
                        </fieldset>
                    </div>
                </div>
                {this.state.errorMessage && (
                    <p className="mb-3 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700" role="alert">
                        {this.state.errorMessage}
                    </p>
                )}
                <div>
                    <button 
                        disabled={this.state.disabledButton}
                        onClick={() => {this.endItemCreation()}}
                        type="button"
                        className={BUTTON_LINE_ICON}>
                        FINALIZAR
                    </button>
                    <button  
                        className='bg-white text-gray-900'
                        style={{marginLeft:10}}                  
                        onClick={() => {this.props.closeDialog()}}
                        type="button"
                    >
                        CANCELAR
                    </button>
                </div>
                {this.renderNotification()}
            </div>
                }
            </div>
           
        )
    }  
}

export default NewRule;